var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('item-filters',{attrs:{"getParams":_vm.getParams,"disableds":_vm.disableds,"decorators":_vm.decorators}}),_c('sku-list',{ref:"SKU_LIST",attrs:{"filterSkuCallback":_vm.filterSkuCallback}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }